import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://itfqoxsxintdzaofhydf.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml0ZnFveHN4aW50ZHphb2ZoeWRmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjEyNjUyMzksImV4cCI6MjA3Njg0MTIzOX0.O7_5fz2x8at5iwEBcX0QuafSTCXw3IfkskiTiYuw4XU'

export const supabase = createClient(supabaseUrl, supabaseKey)
